export default "__VITE_ASSET__gBCRCpyS__"